import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable,of } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class RdTokenService {

  private rdEnvironment = 'PROD'; // You can choose which environment to use PROD, STAGE or DEV
  private rdPublishableKey = 'cAG0DZdyJ240Gzci4lBgv2oqdbOGJ7vJ8AYnNTvY';
  private rdTokenEndpoint = `https://${this.rdEnvironment}.resdefio.com/token`;


  constructor(private http: HttpClient) { }

  private generateUUID(): string {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  private getCeUd(): string {
    const ceUdKey = 'ce_ud';
    let ceUd = localStorage.getItem(ceUdKey);

    if (!ceUd) {
      ceUd = this.generateUUID();
      localStorage.setItem(ceUdKey, ceUd);
    }

    return ceUd;
  }

  getToken(doCheckActivity:number): Observable<string> {
    if(doCheckActivity==1)
      {
    const ceUd = this.getCeUd();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': this.rdPublishableKey,
      'x-ce-ud': ceUd
    });

    return this.http.get<any>(this.rdTokenEndpoint, { headers }).pipe(
      map(response => response.Results[0].Tokens[0])
    );
  }
  else{
    return of('');
  }
  }
}
